<p-toast position="bottom-right"></p-toast>

<div class="card">
  <div class="card-header bg-gradient-gray-dark text-orange">
    <div class="row">
      <div class="col-10">
        <i *ngIf="lineSummary.isMonitored" class="fas fa-desktop {{getViewClass(lineSummary)}}"></i>
        <i *ngIf="!lineSummary.isMonitored" class="fas fa-times-circle "></i>
        &nbsp;<strong>{{lineSummary?.fakeName}}</strong>
      </div>
      <!--<div class="col-2">
        <button class="btn btn-dark" (click)="goToCreateTicket()" style="float:right">Create Ticket</button>

      </div>-->
    </div>

  </div>
  <div class="row text-center"  >
    <div *ngIf="lineSummary?.isSnoozedNow" class="col-md-12 col-sm-12"  >
      <p style="align-content:center; background-color:yellow"><strong style="color:darkorange" >This Line Is Snoozing  now  , till {{lineSummary?.snoozedTill | date:'medium'}}</strong></p>
    </div>
  </div>
  <div class="row card-body">

    <div class="col-3">
      <div class="info-box card-primary">
        <span class="info-box-icon"><i class="fas fa-download text-success"></i></span>
        <div class="info-box-content">
          <span class="info-box-text">Speed</span>
          <!--<span class="info-box-number">{{lineSummary?.lineSpeed | speedKbToMb}}</span>-->
        <span class="info-box-number">{{lineSpeed}}</span>
        </div>
      </div>
    </div>

    <div class="col-3">
      <div class="info-box card-primary">
        <span class="info-box-icon"><i class="fas fa-phone-square text-warning"></i></span>
        <div class="info-box-content">
          <span class="info-box-text">Pop</span>
          <span class="info-box-number">{{lineSummary?.popName}}</span>
        </div>
      </div>
    </div>

    <div class="col-3">
      <div class="info-box card-primary">
        <span class="info-box-icon"><i class="fas fa-cog text-info"></i></span>
        <div class="info-box-content">
          <span class="info-box-text">Service</span>
          <span class="info-box-number">{{lineSummary?.serviceName}}</span>
        </div>
      </div>

    </div>
    <div class="col-3">
      <div class="info-box card-primary">
        <span class="info-box-icon"><i class="fas fa-inbox text-success"></i></span>
        <div class="info-box-content">
          <span class="info-box-text">Product</span>
          <span class="info-box-number">{{lineSummary?.productName}}</span>
        </div>
      </div>
    </div>
    <div class="overlay dark" style="display:flex;" *ngIf="loader">
      <i class="fas fa-2x fa-sync-alt fa-spin"></i>
    </div>
  </div>

</div>

<p-dialog header="Create ticket" *ngIf="showSubmitTicket" [(visible)]="showSubmitTicket"
          [modal]="true" [style]="{width: '50vw',color:'darkorange' }"
          [draggable]="false" [resizable]="true" [blockScroll]="false">
  <app-create-ticket [lineSummary]="lineSummary" (closeTicketsDialog)="onDialogTicketsClose($event)"></app-create-ticket>
</p-dialog>
